import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import moment from 'moment';
import {
  getDisabledDays,
  getDisabledWeekdays,
  getDateExtraFee,
  getMinDate,
  getDate,
  getMode,
  setDate,
  getIsDisabled,
  dateModes,
  isSunday,
  isSaturday,
} from '../../features/commerce/delivery/dates';
import { getFeePrice } from '../../features/commerce/selectors';
import { getDeliveryType, deliveryTypes } from '../../features/commerce/delivery';
import { getErrorIfShow } from '../../features/form-error/selectors';
import { validateFieldRequest } from '../../features/form-error/actions';
import { Paragraph } from '../../components/typography';
import { Money } from "../commerce";
import { dayFormat } from '../../content/commerce/closedDates';

const convertToDates = createSelector(
  disabledDays => disabledDays,
  disabledDays => disabledDays.map(
    disabledDay => moment(disabledDay, dayFormat).toDate(),
  ),
);
export default deliveryType => dateType => connect(
  state => ({
    dateType,
    deliveryType,
    isHidden: getMode(deliveryType)(dateType)(state) === dateModes.none,
    disabled: (getDeliveryType(state) !== deliveryType || getIsDisabled(deliveryType)(dateType)(state)),
    disabledWeekDays: getDisabledWeekdays(deliveryType)(dateType)(state),
    disabledDays: convertToDates(getDisabledDays(deliveryType)(dateType)(state)),
    date: getDate(deliveryType)(dateType)(state),
    minDate: getMinDate(deliveryType)(dateType)(state),
    error: getErrorIfShow(state, { container: 'delivery', field: dateType }),
    getDayText: (date) => {
      let extraCost = 0;
      if ((
        (
          date.isSame(moment(), 'day')
          || isSunday(date)
        )
        && deliveryType !== deliveryTypes.no
      )
        || (
          (
            isSunday(date)
            || isSaturday(date)
          )
          && deliveryType === deliveryTypes.no
        )
      ) {
        return (
          <Paragraph fontSize="10px" grey marginTop="0" textCenter>
            +Tillæg
          </Paragraph>
        );
      }
      extraCost = getDateExtraFee(deliveryType)(dateType)(date)(state);
      extraCost = getFeePrice(state)(extraCost);
      if (extraCost > 0) {
        return (
          <Paragraph fontSize="10px" grey marginTop="0" textCenter>
            +<Money money={extraCost} noSuffix noDecimal />,-
          </Paragraph>
        );
      }
      return null;
    },
  }),
  dispatch => ({
    onDateChange: (date) => {
      dispatch(setDate(deliveryType)(dateType)(date));
      dispatch(validateFieldRequest({ container: 'delivery', dateType }));
    },
  }),
);
